import { useSelector } from "react-redux";
import { useGetAfishaQuery } from "../../features/CallApi";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { AfishaSlider } from "./AfishaSlider";
import { Repertoire } from "../Show/Repertoire";
import ContentLoader from "react-content-loader";

const AfishaLoder = () => {

    return (
        <div className="mt-1 mb-1 pt-3 pb-3 border-bottom" >
            <Row className="g-3 justify-content-around">
                <Col
                    xs={6}
                    md={4}
                >
                    <ContentLoader
                        className={'img-fluid'}
                        backgroundColor="#dedede"
                        foregroundColor="#ecebeb"
                        speed={0.5}

                        viewBox="0 0 1080 1620">
                        {/* Only SVG shapes */}
                        <rect x="0" y="0" rx="5" ry="5" width="100%" height={'100%'} />
                    </ContentLoader>
                </Col>
                <Col
                    xs={6}
                    md={4}
                >
                    <ContentLoader
                        className={'img-fluid'}
                        backgroundColor="#dedede"
                        foregroundColor="#ecebeb"
                        speed={0.5}

                        viewBox="0 0 1080 1620">
                        {/* Only SVG shapes */}
                        <rect x="0" y="0" rx="5" ry="5" width="100%" height={'100%'} />
                    </ContentLoader>
                </Col>
            </Row>
        </div>
    )
}

export const AfishaHome = () => {
    const selLanguage = useSelector((state: any) => state.language)
    const { data: dataAfisha, isLoading: loadingAfisha } = useGetAfishaQuery({ selLanguage })
    const [t] = useTranslation("global");

    return (
        <div className="mt-1 mb-1 pt-3 pb-3">
            <Container>
                {!loadingAfisha ?
                    <>
                        {dataAfisha?.length > 0 &&
                            <div className="mt-1 mb-1 pt-3 pb-3 border-bottom">
                                <h2>{t("general.playbill")}</h2>
                                <AfishaSlider items={dataAfisha} />
                            </div>
                        }
                        {dataAfisha?.length === 0 &&
                            <div className="mt-1 mb-1 pt-3 pb-3 border-bottom">
                                <h2>{t("general.repertoire")}</h2>
                                <Repertoire />
                            </div>
                        }
                    </>
                    :
                    <AfishaLoder />
                }
            </Container>
        </div>
    )
}